var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { CompletedStep, ConfirmPanicButtonEventProcessStep, ProcessStep } from 'Components.Structure';
import { injectIntl } from 'Intl';
import { resolveAccessoryTranslation } from 'Utils';
var onlyHandledAccessoryTypes = function (accessory) {
    var _a, _b, _c;
    return (((_a = accessory.accessoryType) === null || _a === void 0 ? void 0 : _a.key) === 'PANIC_BUTTONS'
        || ((_b = accessory.accessoryType) === null || _b === void 0 ? void 0 : _b.key) === 'ADAS_CAMERA'
        || ((_c = accessory.accessoryType) === null || _c === void 0 ? void 0 : _c.key) === 'DSM_CAMERA');
};
var CalibrateAccessoriesProcessStep = /** @class */ (function (_super) {
    __extends(CalibrateAccessoriesProcessStep, _super);
    function CalibrateAccessoriesProcessStep(props) {
        var _this = _super.call(this, props) || this;
        _this.handleConfirm = function (hasSelfCertifed) {
            var _a = _this.state, currentIndex = _a.currentIndex, accessories = _a.accessories;
            var length = accessories.filter(onlyHandledAccessoryTypes).length;
            var nextIndex = currentIndex + 1;
            var calibrateComplete = length === nextIndex;
            var newAccessories = accessories.map(function (accessory, index) {
                if (index !== currentIndex)
                    return accessory;
                return __assign(__assign({}, accessory), { tested: true, selfCertified: hasSelfCertifed });
            });
            _this.setState({
                currentIndex: calibrateComplete ? currentIndex : nextIndex,
                accessories: newAccessories,
            }, function () {
                if (calibrateComplete) {
                    _this.props.onConfirm(newAccessories);
                }
            });
        };
        _this.handleEdit = function (index) { return function () {
            _this.setState(function (prev) { return ({
                currentIndex: index,
                accessories: prev.accessories.map(function (acc, i) { return (i >= index
                    ? __assign(__assign({}, acc), { tested: false }) : acc); }),
            }); });
            _this.props.onEdit();
        }; };
        _this.handleIntegratedPanicConfirm = function (hasSelfCertifed) {
            _this.setState({
                integratedPanicCalibrated: true,
            });
            if (_this.state.accessories.filter(onlyHandledAccessoryTypes).length === 0) {
                var accessories_1 = [];
                _this.state.accessories.forEach(function (accessory) {
                    var newAccessory = accessory;
                    newAccessory.selfCertified = hasSelfCertifed;
                    accessories_1.push(newAccessory);
                });
                _this.props.onConfirm(accessories_1);
            }
        };
        _this.handleIntegratedPanicEdit = function () {
            _this.setState({
                currentIndex: 0,
                integratedPanicCalibrated: false,
            });
            _this.props.onEdit();
        };
        _this.state = {
            currentIndex: 0,
            integratedPanicCalibrated: props.hasIntegratedPanicButton ? false : null,
            accessories: [],
        };
        return _this;
    }
    CalibrateAccessoriesProcessStep.prototype.componentDidMount = function () {
        var _a = this.props, hasIntegratedPanicButton = _a.hasIntegratedPanicButton, accessories = _a.accessories, onConfirm = _a.onConfirm;
        if (!hasIntegratedPanicButton && accessories.filter(onlyHandledAccessoryTypes).length === 0) {
            onConfirm(accessories);
        }
        this.setState({ accessories: accessories });
    };
    CalibrateAccessoriesProcessStep.prototype.render = function () {
        var _this = this;
        var _a = this.props, device = _a.device, startStep = _a.startStep, baseId = _a.baseId, intl = _a.intl, accessorySelfCertifed = _a.accessorySelfCertifed, showSelfCertify = _a.showSelfCertify;
        var _b = this.state, currentIndex = _b.currentIndex, integratedPanicCalibrated = _b.integratedPanicCalibrated, accessories = _b.accessories;
        return (React.createElement(React.Fragment, null,
            integratedPanicCalibrated != null && (React.createElement(ConfirmPanicButtonEventProcessStep, { baseId: "".concat(baseId, "_confirmPanicButtonEvent"), label: intl.formatMessage('common.stepLabel', {
                    stepNumber: startStep,
                }), subtitle: intl.formatMessage('calibrateAccessories.integratedPanicDescription'), completedTitle: intl.formatMessage('calibrateAccessories.eventReceivedTitle'), completedSubtitle: intl.formatMessage('calibrateAccessories.integratedCompletedSubtitle'), deviceId: device.id, onConfirm: this.handleIntegratedPanicConfirm, onEdit: this.handleIntegratedPanicEdit, accessorySelfCertifed: accessorySelfCertifed, showSelfCertify: showSelfCertify })),
            integratedPanicCalibrated == null || integratedPanicCalibrated ? accessories
                .filter(onlyHandledAccessoryTypes)
                .map(function (accessory, index) {
                if (index > currentIndex)
                    return null;
                var accessoryName = accessory.catalogueId != null
                    ? intl.formatMessage(resolveAccessoryTranslation(accessory.catalogueId))
                    : accessory.name;
                switch (accessory.catalogueId) {
                    case 'ADAS_CAMERA_1':
                    case 'DSM_CAMERA_1':
                        return (React.createElement(ProcessStep, { key: accessory.catalogueId, baseId: "".concat(baseId, "_confirm_").concat(index), label: intl.formatMessage('common.stepLabel', {
                                stepNumber: integratedPanicCalibrated != null
                                    ? (startStep || 0) + index + 1
                                    : (startStep || 0) + index,
                            }), subtitle: intl.formatMessage(accessory.catalogueId === 'ADAS_CAMERA_1'
                                ? 'calibrateAccessories.adasCameraDescription'
                                : 'calibrateAccessories.dsmCameraDescription'), confirmedContent: (React.createElement(CompletedStep, { title: intl.formatMessage(accessory.catalogueId === 'ADAS_CAMERA_1'
                                    ? 'calibrateAccessories.adasCameraCompletedTitle'
                                    : 'calibrateAccessories.dsmCameraCompletedTitle') })), activeContent: null, confirmed: accessory.tested || false, onConfirm: function () {
                                _this.handleConfirm(false);
                            }, onEditStep: _this.handleEdit(index) }));
                    default:
                        return (React.createElement(ConfirmPanicButtonEventProcessStep, { key: accessory.catalogueId, baseId: "".concat(baseId, "_confirmPanicButtonEvent_").concat(index), label: intl.formatMessage('common.stepLabel', {
                                stepNumber: integratedPanicCalibrated != null
                                    ? (startStep || 0) + index + 1
                                    : (startStep || 0) + index,
                            }), subtitle: intl.formatMessage('calibrateAccessories.externalPanicDescription'), completedTitle: intl.formatMessage('calibrateAccessories.eventReceivedTitle'), completedSubtitle: intl.formatMessage('calibrateAccessories.accessoryRaisedPanicEvent', {
                                name: accessoryName,
                            }), deviceId: device.id, fromAlarms: true, onConfirm: _this.handleConfirm, onEdit: _this.handleEdit(index), accessorySelfCertifed: accessory.selfCertified || false, showSelfCertify: showSelfCertify }));
                }
            }) : null));
    };
    CalibrateAccessoriesProcessStep.defaultProps = {
        hasIntegratedPanicButton: false,
        startStep: 1,
    };
    return CalibrateAccessoriesProcessStep;
}(React.PureComponent));
export default injectIntl(CalibrateAccessoriesProcessStep);
